import styled, { css } from 'styled-components';

import { breakpoints } from '@shared/constants';

export const SettingsHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;

    @media (max-width: ${breakpoints.md}px) {
        margin-bottom: 30px;
    }
`;

export const CompanyLogo = styled.img`
    max-height: 40px;
    max-width: 140px;

    @media (max-width: ${breakpoints.xs}px) {
        max-height: 34px;
        max-width: 115px;
    }
`;

export const SettingsCard = styled.div(
    ({ theme: { boxShadow, palette, radius } }) => css`
        background-color: ${palette.neutral.white};
        border-radius: ${radius[6]}px;
        box-shadow: ${boxShadow.small};
        padding: 48px 52px;

        & ~ & {
            margin-top: 8px;
        }

        @media (max-width: ${breakpoints.xs}px) {
            padding: 24px 25px;
        }
    `,
);
